<template>
  <PreviewCellWrapper :cell-list="cellList" :thumbnail-info="thumbnailInfo" />
</template>
<script setup lang="ts">
  import { computed, defineProps } from 'vue'
  import { previewCell } from '@/common/utils/like-status/preview-cell'
  import PreviewCellWrapper from '@/pages/list/commingsoon/PreviewCellWrapper.vue'

  const props = defineProps({
    contextList: {
      type: Array,
      default: () => [],
      required: true,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
  })

  const cellList = computed(() => previewCell(props.contextList))
</script>
